import PhotoAdmin from './PhotoAdmin';

export default PhotoAdmin;
